import config from '../config';

export const defaultState = {
  userId: null,
  authToken: null,
  userName: null,
  userEmail: null,
  countryCode: null,
  userPhone: null,
  dateOfBirth: null,
  userAge: 0,
  userGender: null,
  otpVerified: false,
  emailVerified: false,
  sponsorId: 0,
  verifiedSponsor: false,
  userUUID: null,
  platform: null,
  oldPhone: null,
  versionCode: null,
  referralCode: null,
  referralLink: null,
  createdAt: null,
  ftAvailable: false,
  sponsorCommonName: null,
  feedAvailable: false,
  qChat: false,
  inviteShareText: null,
  profileImage: null,
  inviteFitReward: null,
  supportPhone: null,
  streamId: 0,
  userChannelGroup: null,
  validateSponsor: false,
  walletBalance: 0,
  searchText: '',
  manageDependentLink: '',
  ticketingUrl: config.ticketingBaseUrl,
  selectedVerticalByUser: '',
  showUnlockGymSession: true,
  setHealthHistory: [],
  setHeight: '',
  setWeight: '',
  bmi: 0,
  setHealthGoal: [],
  setFoodPreference: '',
  setFavFood: [],
  setAllergicFood: [],
  setPhysicalActivity: '',
  loggedMeal: [],
  vaccineId: '',
  cult: null,
  vaccinationCategoryIdFilters: [],
  vaccinationCategoryNameFilters: [],
  relativeId: null,
  policyNumber: null,
  locationInfo: {
    lat: null,
    long: null,
    pincode: null,
    locationName: null,
  },
  searchBook: {
    recentSearches: [],
    cartItemDetails: [],
    userEmail: '',
    cart: {
      items: [],
      totalPrice: 0,
    },
    showWalletModal: false,
  },
  isWipro: '',
};

export default function user(state = defaultState, action) {
  switch (action.type) {
    case 'SET_USER_INFO': {
      const { userInfo: userInfoData, ...loginMeta } = action.payload;
      return Object.assign({}, state, userInfoData, { loginMeta });
    }
    case 'UNSET_USER_INFO':
      return Object.assign({}, defaultState);
    case 'AUTH_TOKEN':
      return Object.assign({}, state, {
        authToken: action.payload,
      });
    case 'SET_FITCOIN_BALANCE':
      return Object.assign({}, state, {
        walletBalance: action.payload.balance,
      });
    case 'SET_SEARCH_TEXT':
      return Object.assign({}, state, {
        searchText: action.payload,
      });
    case 'SET_MANAGE_DEPENDENT_LINK':
      return Object.assign({}, state, {
        manageDependentLink: action.payload,
      });
    case 'SET_USER_NAME':
      return Object.assign({}, state, {
        userName: action.payload,
      });
    case 'SET_USER_EMAIL':
      return Object.assign({}, state, {
        userEmail: action.payload,
      });
    case 'SET_USER_GENDER':
      return Object.assign({}, state, {
        userGender: action.payload,
      });
    case 'SET_TICKETING_URL':
      return Object.assign({}, state, {
        ticketingUrl: action.payload,
      });
    case 'SET_CURRENT_VERTICAL':
      return Object.assign({}, state, {
        selectedVerticalByUser: action.payload,
      });
    case 'SHOW_UNLOCK_GYM_SESSION':
      return Object.assign({}, state, {
        showUnlockGymSession: action.payload,
      });
    case 'SET_HEALTH_HISTORY':
      return Object.assign({}, state, {
        setHealthHistory: action.payload,
      });
    case 'SET_WEIGHT':
      return Object.assign({}, state, {
        setWeight: action.payload,
      });
    case 'SET_HEIGHT':
      return Object.assign({}, state, {
        setHeight: action.payload,
      });
    case 'SET_BMI':
      return Object.assign({}, state, {
        bmi: action.payload,
      });
    case 'SET_HEALTH_GOAL':
      return Object.assign({}, state, {
        setHealthGoal: action.payload,
      });
    case 'SET_FOOD_PREFERENCE':
      return Object.assign({}, state, {
        setFoodPreference: action.payload,
      });
    case 'SET_FAV_FOOD':
      return Object.assign({}, state, {
        setFavFood: action.payload,
      });
    case 'SET_ALLERGIC_FOOD':
      return Object.assign({}, state, {
        setAllergicFood: action.payload,
      });
    case 'SET_PHYSICAL_ACTIVITY':
      return Object.assign({}, state, {
        setPhysicalActivity: action.payload,
      });
    case 'LOGGED_MEAL':
      return Object.assign({}, state, {
        loggedMeal: action.payload,
      });
    case 'SET_CURRENT_VACCINE_ID':
      return Object.assign({}, state, {
        vaccineId: action.payload,
      });
    case 'SET_CULT_CARD':
      return Object.assign({}, state, {
        cult: action.payload,
      });
    case 'VACCINATION_CATEGORY_ID_FILTERS':
      return Object.assign({}, state, {
        vaccinationCategoryIdFilters: action.payload,
      });
    case 'VACCINATION_CATEGORY_NAME_FILTERS':
      return Object.assign({}, state, {
        vaccinationCategoryNameFilters: action.payload,
      });
    case 'SET_USER_UUID':
      return Object.assign({}, state, {
        userUUID: action.payload,
      });
    case 'SET_INITIAL_STATE':
      return { ...defaultState };
    case 'SEARCH_BOOK_RECENT_SEARCH': {
      let searchArray = state?.searchBook?.recentSearches || [];
      const word = action.payload;
      if (!searchArray?.includes(word)) {
        // if item doesn't exist then push this as first item and if total items more than 10 remove last item
        searchArray?.unshift(word);
      } else {
        // if item exists but not in first position
        // remove it from that index
        // and push it as first item
        let index = searchArray?.indexOf(word);
        if (index !== 0) {
          searchArray.splice(index, 1);
          searchArray.unshift(word);
        } else {
          // do nothing and let searchArray as it is
        }
      }
      if (searchArray?.length > 10) {
        searchArray?.pop(); // mutates the array
      }
      return Object.assign({}, state, {
        searchBook: { ...state.searchBook, recentSearches: searchArray },
      });
    }
    case 'SET_SEARCH_BOOK_CART_ITEMS': {
      console.log('SET_SEARCH_BOOK_CART_ITEMS here');
      return Object.assign({}, state, {
        searchBook: {
          ...state.searchBook,
          cart: {
            items: action.payload.cartItems,
            totalPrice: action.payload.totalFinalPrice,
          },
        },
      });
    }

    case 'SEARCH_BOOK_CART_ITEMS': {
      let items = state?.searchBook?.cart?.items || [];
      let totalPrice = 0;
      let updatedItems = [];
      switch (action.payload.type) {
        case 'ADD':
          updatedItems = [
            ...items,
            { ...action.payload.item, quantity: action.payload.quantity },
          ];
          break;
        case 'UPDATE':
          updatedItems = items.map((item) => {
            if (item.dimDrugId === action.payload.item.dimDrugId) {
              return {
                ...item,
                quantity: action.payload.quantity,
              };
            }
            return item;
          });
          break;
        case 'REMOVE':
          updatedItems = items.filter(
            (item) => item.dimDrugId !== action.payload.item.dimDrugId
          );
          break;
        default:
          return null;
      }
      if (updatedItems.length === 0) {
        totalPrice = 0;
      } else {
        updatedItems.forEach((item) => {
          totalPrice += Number(item.discountedPrice) * Number(item.quantity);
        });
      }
      return Object.assign({}, state, {
        searchBook: {
          ...state.searchBook,
          cart: {
            items: updatedItems,
            totalPrice: totalPrice.toFixed(2),
          },
        },
      });
    }
    case 'SEARCH_BOOK_USER_EMAIL': {
      return Object.assign({}, state, {
        searchBook: { ...state.searchBook, userEmail: action.payload },
      });
    }
    case 'SET_SEARCH_BOOK_COVERAGE_MODAL': {
      return Object.assign({}, state, {
        searchBook: { ...state.searchBook, showWalletModal: action.payload },
      });
    }
    case 'SET_LOCATION_INFO': {
      if (action.payload)
        return Object.assign({}, state, {
          locationInfo: action.payload,
        });
      else
        return Object.assign({}, state, {
          locationInfo: {
            lat: null,
            long: null,
            pincode: null,
            locationName: null,
          },
        });
    }
    case 'IS_WIPRO_USER': {
      return Object.assign({}, state, {
        isWipro: action.payload,
      });
    }
    default:
      return state;
  }
}
